import { atom } from 'recoil';
import { recoilPersist } from 'recoil-persist';

const { persistAtom } = recoilPersist({
    key: 'application',
    storage: sessionStorage,
});

export default atom({
    key: 'application',
    default: {
        company_id: null,
        estate_id: null
    },
    effects_UNSTABLE: [persistAtom],
});
